export const COOKIE_NAME = "GDPR_COOKIES_ACCEPT";
export const COOKIE_STANDARD = "STANDARD";
export const COOKIE_RESTRICTED = "RESTRICTED";
export const COOKIE_HIGHLY_RESTRICTED = "HIGHLY_RESTRICTED";

const ONE_YEAR = 365;
const THREE_YEARS = 3 * ONE_YEAR;
const FIFTY_YEARS = 50 * ONE_YEAR;

const protocolEqualsHttps = window.location.protocol === "https:";

export const AcceptCookieOption = {
  expires: THREE_YEARS,
  path: "/",
  ...(protocolEqualsHttps && { sameSite: "none" }),
  ...(protocolEqualsHttps && { secure: true }),
};

export const SelectCountryOption = {
  expires: FIFTY_YEARS,
  path: "/",
};

export const options = [
  {
    key: COOKIE_STANDARD,
    translation: "CookieMessage.settings.standard",
    icon: "option_full",
  },
  {
    key: COOKIE_RESTRICTED,
    translation: "CookieMessage.settings.restricted",
    icon: "option_middle",
  },
  {
    key: COOKIE_HIGHLY_RESTRICTED,
    translation: "CookieMessage.settings.highly_restricted",
    icon: "option_min",
  },
];
